import CityPageTemplate from "../city-template/CityPageTemplate";
import { dentonConfig } from "./data";

export default function DentonPage() {
  return <CityPageTemplate config={dentonConfig} />;
}